import { POPUPS } from '@common/constants/popups';
import { swarmRequest } from '@common/helpers/util/requestMiddleware';

import { FinishRegistration } from '../actions/user';
import { getPopupDispatchers } from '../contexts/popup';
import { getSwarmSetRfidPinCodeRequest } from './terminalRequests/rfid';
import { store } from '../index/terminalApp';
import Config from '../config/main';

export function registerFromCSharp(params, isSuccess) {
  const { openPopup } = getPopupDispatchers();

  const { token } = JSON.parse(sessionStorage.getItem('authData'));
  const data = JSON.parse(params);
  let textCode;

  if (!isSuccess) return;

  swarmRequest({
    token,
    user_info: {
      FirstName: data.Name,
      LastName: data.Surname,
      Email: data.Email,
      DocNumber: data.CNP,
      MobileNumber: data.Phone,
      RFID: data.CardId,
      BTag: data.BTag,
      CurrencyId: 'RON',
      RegionId: 189,
    },
  }, 'terminal_create_player')
    .then(async (response) => {
      textCode = response.text_code;
      if (response.text_code === '0') {
        if (Config.main.rfidPinCode) {
          const reqParams = {
            PinCode: '0000',
            Rfid: data.CardId,
          };

          await swarmRequest(getSwarmSetRfidPinCodeRequest(reqParams), 'betshop_command');
        }
        store.dispatch(FinishRegistration(true));
        openPopup(POPUPS.REGISTER_SUCCESS);
      } else {
        store.dispatch(FinishRegistration(false));
        openPopup(POPUPS.FAIL_POPUP, { textCode });
      }
    })
    .catch((error) => console.warn(error));
}
